import React, { useEffect, useRef, useState } from "react";
import Header from "../Sections/Investor/Header/Header";
import Banner from "../Sections/Investor/Banner/Banner";
import Choose from "../Sections/Investor/Zowo/Choose";
import FAQ from "../Sections/Investor/FAQs/FAQ";
import BecomeInvestor from "../Sections/Investor/BecomeInvestor/BecomeInvestor";
import FreeApp from "../Sections/Download/FreeApp";
import Footer from "../Footer/Footer";

const Investor = () => {
  return (
    <>
      <Header />
      <Banner></Banner>
      <BecomeInvestor></BecomeInvestor>
      <Choose></Choose>
      <FAQ></FAQ>
      <FreeApp></FreeApp>
      <Footer></Footer>
    </>
  );
};
export default Investor;
